var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-more"},[_c('button',{staticClass:"btn--white",on:{"click":_vm.buttonCick}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"load-more__error"},[_vm._v(_vm._s(_vm.loadErrorMsg))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }